module.exports = __webpack_public_path__ + "static/services-dedicated-teams-6965074c824d5bd6a6eda82b9a8159e5.svg";